export const RouteKeys = {
	HOME: 'home',
	ACTIVATION: 'activation',
	ACTIVATE: 'activate',
	ACTIVATION_FRANCE_CONNECT: 'activation.france-connect',
	ACTIVATION_MERGE: 'activation.merge-with-france-connect',
	DOCUMENTS: 'documents',
	FC: 'france-connect',
	LOGIN: 'login',
	SHARES: 'shares',
	PUBLIC_SHARES: 'public-shares',
	LOGIN_SHARES: 'login-shares',
	PUBLIC_SHARES_EXPIRED: 'public-shares-expired',
	NOT_FOUND: '404',
	TRASH: 'trash',
	ACCOUNT: 'account',
	PROFILE_INFOS: 'account.profile-infos',
	SAFETY: 'account.safety',
	MERGE: 'account.merge',
	DEMAT: 'account.demat',
	COLLECTORS: 'collectors',
	FRANCE_CONNECT: 'account.france-connect',
	EXPORT: 'account.export',
	RESET_PASSWORD: 'reset-password'
};
